import type {
  CollectionReference,
  DocumentReference,
  Firestore,
} from "firebase/firestore";
import { collection, doc } from "firebase/firestore";

import { smileSimulationConverter } from "./converter.js";
import type { SmileSimulation } from "./schema.js";

export const SMILE_SIMULATION_COLLECTION = "smileSimulation";
export const SMILE_SIMULATIONS_SUBCOLLECTION = "simulations";

export const smileSimulationClinicDocPath = (clinicId: string) =>
  `${SMILE_SIMULATION_COLLECTION}/${clinicId}`;

export const smileSimulationDocPath = (
  clinicId: string,
  simulationId: string,
) =>
  `${smileSimulationClinicDocPath(clinicId)}/${SMILE_SIMULATIONS_SUBCOLLECTION}/${simulationId}`;

export const smileSimulationClinicDoc = (
  firestore: Firestore,
  clinicId: string,
) => doc(firestore, SMILE_SIMULATION_COLLECTION, clinicId);

export const smileSimulationCollection = (
  firestore: Firestore,
  clinicId: string,
): CollectionReference<SmileSimulation> =>
  collection(
    smileSimulationClinicDoc(firestore, clinicId),
    SMILE_SIMULATIONS_SUBCOLLECTION,
  ).withConverter(smileSimulationConverter);

export const smileSimulationDoc = (
  firestore: Firestore,
  clinicId: string,
  simulationId: string,
): DocumentReference<SmileSimulation> =>
  doc(smileSimulationCollection(firestore, clinicId), simulationId);
